import React from 'react'
import './NewAssetDetailComponent.scss'
import dummyMeterIcon from '../../assets/icons/dummuMeterIcon.svg'
import { validateNullValues, validatePowerFactor } from './AssetDetailsUtils'

function LiveMeterCard({metersDataArr, checkThresHoldValue, el, fullSize}) {
    return (
        <div style={{ width: (fullSize !== undefined && fullSize === true) ? metersDataArr.length === 1 ? 'auto' : '48%' : 'auto' }} key={el.name} className='newAssetMeterDetailsCard'>
            <p>{el.name}</p>
            <div className='meterDetailsIocnAndLabelContainer'>

                {el.imgUrl !== null && <div className='meterDetailsReUseIconContainer'>
                    <img src={el.imgUrl} />
                </div>}

                <div className='meterDetailsCardDymanicLabelsAndValuesConatiner'>
                    {el.options.sort((a,b)=> a.sequenceNo - b.sequenceNo).map((ele) => <div key={ele.name} className='meterDetailsCardDymanicLabelsAndValuesCardConatiner'>
                        <p> {el.name === 'Meter reading' ? `${ele.name}` : ele.name}</p>
                        <h3  style={{color:checkThresHoldValue(el.name, 'color')}} > {el.name === 'Power factor' ? validatePowerFactor(ele.value, ele.readingUomDesc, ele.decimalControl) : validateNullValues(ele.value, ele.readingUomDesc, ele.decimalControl)} </h3>
                        {checkThresHoldValue(el.name,'content').length !== 0 && <p className='minMaxFontText'>
                                                    {
                                                        checkThresHoldValue(el.name,'content').length == 3 ?
                                                        <><span>Min</span> {checkThresHoldValue(el.name,'content')[0]} { checkThresHoldValue(el.name,'content')[2]} - <span>Max</span> {checkThresHoldValue(el.name,'content')[1]} {checkThresHoldValue(el.name,'content')[2]}</> : 
                                                        <><span>Limit </span>{checkThresHoldValue(el.name,'content')[0]} { checkThresHoldValue(el.name,'content')[1]} </>
                                                    }      
                                                    </p>}
                    </div>)}
                </div>
            </div>
        </div>
    )
}

export default LiveMeterCard